import { render } from "./CreditReturnsHistory.vue?vue&type=template&id=32d7c88f&scoped=true"
import script from "./CreditReturnsHistory.vue?vue&type=script&lang=js"
export * from "./CreditReturnsHistory.vue?vue&type=script&lang=js"

import "./CreditReturnsHistory.vue?vue&type=style&index=0&id=32d7c88f&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32d7c88f"]])

export default __exports__